import React from 'react';
import { Typography, Space, Button, Card, Row, Col } from 'antd';
import { Link } from 'react-router-dom';
import {
  SendOutlined,
  PhoneOutlined,
  RobotOutlined,
  WhatsAppOutlined,
  CustomerServiceOutlined,
  BarChartOutlined,
  ShareAltOutlined,
  CommentOutlined,
} from '@ant-design/icons';

const { Title, Paragraph, Text } = Typography;

const LandingPage = () => {
  return (
    <div
      style={{
        textAlign: 'center',
        minHeight: '100vh',
        backgroundColor: '#f0f2f5',
        color: '#333',
      }}
    >
      {/* Sección principal: Título y Eslogan */}
      <div
        style={{
          padding: '80px 20px',
          background: 'linear-gradient(to right, #1890ff, #722ed1)',
          color: 'white',
        }}
      >
        <Title
          level={1}
          style={{ color: 'white', fontSize: '3.5em', marginBottom: '10px' }}
        >
          Automatiza la experiencia de tus clientes
        </Title>
        <Paragraph
          style={{
            color: 'white',
            maxWidth: '900px',
            fontSize: '1.5em',
            lineHeight: '1.5',
            margin: '0 auto 40px auto',
          }}
        >
          Potencia tu área de marketing, ventas o servicio, con nuestra solución
          integral centrada en las interacciones de alto valor.
        </Paragraph>
        <Space size="large">
          <Button
            type="primary"
            size="large"
            icon={<PhoneOutlined />}
            style={{
              background: 'white',
              color: '#1890ff',
              borderColor: 'white',
            }}
            onClick={() =>
              window.open('https://www.nuatechnology.com/contactanos', '_blank')
            }
          >
            Empezar Ahora
          </Button>
          <Link to="/auth/login">
            <Button
              size="large"
              icon={<SendOutlined />}
              style={{
                background: 'transparent',
                color: 'white',
                borderColor: 'white',
              }}
            >
              Acceder a la Plataforma
            </Button>
          </Link>
        </Space>
      </div>

      {/* Sección: Productos y soluciones que harán crecer tu empresa */}
      <div
        style={{ padding: '60px 20px', maxWidth: '1200px', margin: '0 auto' }}
      >
        <Title level={2} style={{ marginBottom: '50px', color: '#001529' }}>
          Productos y soluciones que harán crecer tu empresa
        </Title>

        {/* Producto: Nua Talker */}
        <Row gutter={[32, 32]} align="middle" style={{ marginBottom: '80px' }}>
          <Col xs={24} md={12} style={{ textAlign: 'left' }}>
            <Title level={3}>
              <RobotOutlined
                style={{ marginRight: '10px', color: '#1890ff' }}
              />{' '}
              Nua Talker
            </Title>
            <Text
              strong
              style={{
                fontSize: '1.2em',
                display: 'block',
                marginBottom: '20px',
              }}
            >
              Agente virtual + IA
            </Text>
            <Paragraph>
              Si no logras alcanzar las ventas necesarias ni cumples con todas
              las solicitudes de soporte, esta solución es para ti. Incorpora a
              tu equipo un Agente Virtual que te permitirá:
            </Paragraph>
            <ul>
              <li>
                **Gestionar las 24 horas del día, los 7 días de la semana:**
                Brinda soporte inmediato a tus clientes o comunica tu producto
                sin importar la hora o el día.
              </li>
              <li>
                **Perfilar y cualificar a tus prospectos:** Gestiona llamadas
                entrantes y salientes para identificar a tus _leads_ realmente
                interesados.
              </li>
              <li>
                **Gestionar múltiples llamadas simultáneamente:** Aumenta la
                eficiencia y reduce costos operativos al manejar un alto volumen
                de solicitudes sin necesidad de más asesores.
              </li>
              <li>
                **Personalizar la experiencia de cada cliente:** Ofrece un trato
                personalizado y memorable a cada cliente, recopilando sus datos
                y preferencias para futuras interacciones.
              </li>
            </ul>
            <Button
              type="primary"
              style={{ marginTop: '20px' }}
              onClick={() =>
                window.open(
                  'https://www.nuatechnology.com/agentevirtual',
                  '_blank'
                )
              }
            >
              Más información
            </Button>
          </Col>
          <Col xs={24} md={12}>
            <img
              src="https://www.nuatechnology.com/hubfs/Inteligencia%20Artificial%20Agente%20Virtual%20background.png"
              alt="Agente Virtual"
              style={{
                width: '100%',
                borderRadius: '8px',
                boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
              }}
            />
          </Col>
        </Row>

        {/* Producto: Nua x HubSpot */}
        <Row gutter={[32, 32]} align="middle" style={{ marginBottom: '80px' }}>
          <Col xs={24} md={12}>
            <img
              src="https://www.nuatechnology.com/hubfs/Call%20Blasting%20desde%20hubspot%20background.png"
              alt="Integración HubSpot"
              style={{
                width: '100%',
                borderRadius: '8px',
                boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
              }}
            />
          </Col>
          <Col xs={24} md={12} style={{ textAlign: 'left' }}>
            <Title level={3}>
              <WhatsAppOutlined
                style={{ marginRight: '10px', color: '#722ed1' }}
              />{' '}
              Nua x HubSpot
            </Title>
            <Text
              strong
              style={{
                fontSize: '1.2em',
                display: 'block',
                marginBottom: '20px',
              }}
            >
              Potencia tu CRM favorito
            </Text>
            <Paragraph>
              Integra a tu portal de HubSpot los siguientes canales y soluciones
              que te permitirán:
            </Paragraph>
            <ul>
              <li>
                **Enviar SMS:** Envía un mensaje de texto con los tokens de
                personalización de HubSpot, links y emojis.
              </li>
              <li>
                **Desplegar Call Blasting:** Envía llamadas salientes con audios
                pregrabados o generados por bot y recibe las respuestas en
                propiedades de HubSpot.
              </li>
              <li>
                **Integrar tu Contact Center:** Gestiona tus llamadas entrantes
                y salientes, activa el marcador predictivo y conserva tu número.
                ¡Todo desde el CRM!
              </li>
            </ul>
            <Button
              type="primary"
              style={{ marginTop: '20px' }}
              onClick={() =>
                window.open(
                  'https://www.nuatechnology.com/contactanos',
                  '_blank'
                )
              }
            >
              Contacta a un asesor
            </Button>
          </Col>
        </Row>
      </div>

      {/* Sección: Funcionalidades destacadas */}
      <div
        style={{
          padding: '60px 20px',
          backgroundColor: 'white',
          maxWidth: '1200px',
          margin: '0 auto',
        }}
      >
        <Title level={2} style={{ marginBottom: '50px', color: '#001529' }}>
          Funcionalidades destacadas
        </Title>
        <Row gutter={[16, 16]} justify="center">
          <Col xs={24} md={8}>
            <Card bordered={false} hoverable style={{ height: '100%' }}>
              <BarChartOutlined
                style={{
                  fontSize: '48px',
                  color: '#1890ff',
                  marginBottom: '20px',
                }}
              />
              <Title level={4}>Perfilamiento</Title>
              <Paragraph>
                Haz que tu agente virtual telefónico llame a tus prospectos e
                identifique a los verdaderamente interesados.
              </Paragraph>
              <Button
                type="link"
                onClick={() =>
                  window.open(
                    'https://www.nuatechnology.com/agentevirtual',
                    '_blank'
                  )
                }
              >
                Información
              </Button>
            </Card>
          </Col>
          <Col xs={24} md={8}>
            <Card bordered={false} hoverable style={{ height: '100%' }}>
              <ShareAltOutlined
                style={{
                  fontSize: '48px',
                  color: '#722ed1',
                  marginBottom: '20px',
                }}
              />
              <Title level={4}>Divulgación</Title>
              <Paragraph>
                Brinda información 24/7 a tus clientes potenciales sobre tus
                productos y captura sus datos de contacto.
              </Paragraph>
              <Button
                type="link"
                onClick={() =>
                  window.open(
                    'https://www.nuatechnology.com/agentevirtual',
                    '_blank'
                  )
                }
              >
                Información
              </Button>
            </Card>
          </Col>
          <Col xs={24} md={8}>
            <Card bordered={false} hoverable style={{ height: '100%' }}>
              <CommentOutlined
                style={{
                  fontSize: '48px',
                  color: '#1890ff',
                  marginBottom: '20px',
                }}
              />
              <Title level={4}>Encuestas</Title>
              <Paragraph>
                Despliega encuestas masivas a tus usuarios por canal telefónico
                y recibe las respuestas en tu CRM.
              </Paragraph>
              <Button
                type="link"
                onClick={() =>
                  window.open(
                    'https://www.nuatechnology.com/agentevirtual',
                    '_blank'
                  )
                }
              >
                Información
              </Button>
            </Card>
          </Col>
        </Row>
      </div>
      <div
        style={{ padding: '60px 20px', maxWidth: '1200px', margin: '0 auto' }}
      >
        <Title level={2} style={{ marginBottom: '50px', color: '#001529' }}>
          ¿Por qué elegir Nua Technology?
        </Title>
        <Row gutter={[16, 16]} justify="center">
          <Col xs={24} md={8}>
            <Card bordered={false} style={{ height: '100%' }}>
              <CustomerServiceOutlined
                style={{
                  fontSize: '48px',
                  color: '#1890ff',
                  marginBottom: '20px',
                }}
              />
              <Title level={4}>Soporte Dedicado</Title>
              <Paragraph>
                Nuestro equipo está siempre listo para ayudarte a maximizar el
                potencial de nuestras herramientas.
              </Paragraph>
            </Card>
          </Col>
          <Col xs={24} md={8}>
            <Card bordered={false} style={{ height: '100%' }}>
              <PhoneOutlined
                style={{
                  fontSize: '48px',
                  color: '#1890ff',
                  marginBottom: '20px',
                }}
              />
              <Title level={4}>Comunicación Unificada</Title>
              <Paragraph>
                Integra todos tus canales de comunicación en una sola
                plataforma, simplificando la gestión.
              </Paragraph>
            </Card>
          </Col>
          <Col xs={24} md={8}>
            <Card bordered={false} style={{ height: '100%' }}>
              <SendOutlined
                style={{
                  fontSize: '48px',
                  color: '#1890ff',
                  marginBottom: '20px',
                }}
              />
              <Title level={4}>Innovación Constante</Title>
              <Paragraph>
                Nos comprometemos a evolucionar nuestras soluciones con las
                últimas tecnologías del mercado.
              </Paragraph>
            </Card>
          </Col>
        </Row>
      </div>

      {/* Footer */}
      <div
        style={{
          padding: '30px 20px',
          backgroundColor: '#001529',
          color: 'white',
          marginTop: '60px',
        }}
      >
        <Text style={{ color: 'white' }}>
          © 2023 Nua Technology. Todos los derechos reservados.
        </Text>
      </div>
    </div>
  );
};

export default LandingPage;
